import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PropTypes from 'prop-types';

const RestrictedPopupDialog = ({ isErrorDialogOpen, setIsErrorDialogOpen }) => {
  const handleCloseErrorDialog = () => {
    setIsErrorDialogOpen(false);
  };

  return (
    <Dialog
      open={isErrorDialogOpen}
      onClose={handleCloseErrorDialog}
      maxWidth='sm'
      className='locked-accounts'
    >
      <DialogTitle>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'crimson',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ErrorOutlineIcon sx={{ marginRight: 2 }} /> User is restricted
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ color: '#000' }}>
        <Typography>
          Sorry, this action cannot be completed. The user is restricted due to
          outstanding payment dues.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseErrorDialog} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RestrictedPopupDialog;

RestrictedPopupDialog.propTypes = {
  isErrorDialogOpen: PropTypes.bool,
  setIsErrorDialogOpen: PropTypes.func,
};
